<template>
  <Tour :begin="begin" :tour-name='tourName' :steps="steps" />
</template>

<script>
import {mapGetters} from "vuex";
import Tour from "@/components/tour/Tour";
import {hasSeenTour} from "@/valueholders/constants";

export default {
  name: 'PrognoseLaadpunt',
  components: { Tour },
  computed: {
    ...mapGetters('deployment', [
      'DeploymentCode',
    ]),
    ...mapGetters('app', [
      'isAppReady',
    ]),
  },
  watch: {
    isAppReady(next) {
      if (next) {
        this.init()
      }
    },
  },
  data () {
    return {
      begin: false,
      tourName: 'tooltip-prognose-laadpunt',
      steps: []
    }
  },
  beforeDestroy() {
    if (this.isAppReady && this.$store.map) {
      this.$store.map.off('click', 'hexagons', this.startTour)
      this.$store.map.off('contextmenu', 'hexagons', this.startTour)
    }
  },
  methods: {
    init() {
      if (this.$router.currentRoute.name !== 'Viewer') { return }

      if (! this.$store.map) {
        console.log('MAP NOT READY')
        return
      }

      this.$store.map.on('click', 'hexagons', this.startTour)

      // TODO: Figure out a fix to avoid this
      if (navigator.appVersion.indexOf("Win") === -1) { // OSX
        this.$store.map.on('contextmenu', 'hexagons', this.startTour)
      }

      // until we set the data in auth0, we use cookies
      const localStoreValue = localStorage.getItem(this.tourName)

      if (localStoreValue === hasSeenTour) {
        return
      }

      this.loadSteps();
    },
    startTour() {
      if (! (this.steps.length > 0)) {
        return
      }

      this.begin = true
    },
    loadSteps() {
      let steps = [
        {
          target: '.TileData',
          header: {
            title: 'Laadpunten ipv palen',
          },
          content: `
            <p>Vanaf heden toont de prognose het aantal laadpunten. Eerder spraken we over het aantal laadpalen, maar dit is aangepast naar het aantal laadpunten.</p>
          `,
          customOptions: {
            controls: true,
          },
          params: {
            placement: 'right-start',
            highlight: true,
          }
        }
      ];

      steps = steps.filter((step) => step.customOptions.onlyForDeployments ? step.customOptions.onlyForDeployments.includes(this.DeploymentCode) : true)

      this.setSteps({steps});
    },
    setSteps({steps}) {
      this.steps = steps
    },
    handleSkipTour() {
      this.hideTour()
    },
    hideTour() {
      console.log('hide tour')
      localStorage.setItem(this.tourName, hasSeenTour)
    }
  }
}
</script>
